'use strict';

class UserRegister {
  constructor($scope, $window, userService, commonService, vcRecaptchaService) {
    this.$scope = $scope;
    this.$window = $window;
    this.userService = userService;
    this.commonService = commonService;
    this.vcRecaptchaService = vcRecaptchaService;
  }

  $onInit() {
    this.errors = [];

    this.captchaResponse = null;
    this.organisationForms = [];

    this.user = {
      name: null,
      username: null,
      verifyUsername: null,
      phone: null,
      password: null,
      verifyPassword: null,
      orgNo: null,
      accountNo: null,
      orgForm: 'enk',
      lastInvoiceNo: 1,
      address: {
        address: null,
        zip: null,
        city: null,
        country: 'NORGE'
      },
      mvaRegistered: false,
      foretaksRegistered: false,
      marketing: {
        code: null,
        referer: null
      }
    };

    this.loadCountries();
    this.loadOrganisationForms();

    // get marketing code from url
    const mktCode = decodeURI((new RegExp('mktCode' + '=' + '(.+?)(&|$)').exec(location.search) || ['', null])[1]);
    if (mktCode !== 'null') {
      this.user.marketing.code = mktCode;
    }

    // get referrer from header
    const referer = document.referrer;
    if (referer !== '') {
      this.user.marketing.referer = referer;
    }

    this.$scope.$on('selectedBrreg', (e, val) => {
      angular.extend(this.user, {
        name: val.name,
        phone: val.phone,
        orgNo: val.orgNo,
        orgForm: val.orgForm,
        address: {
          address: val.address.address1,
          zip: val.address.zip,
          city: val.address.city,
          country: val.address.country
        },
        mvaRegistered: val.mvaRegistered,
        foretaksRegistered: val.foretaksRegistered
      });
    });
  }

  loadCountries() {
    this.countries = ['NORGE'];
    this.commonService.getCountries()
      .then((resp) => {
        this.countries = resp;
      });
  }

  loadOrganisationForms() {
    this.commonService.getOrganisationForms()
      .then((resp) => {
        this.organisationForms = resp;
      });
  }

  excludePrivate(item) {
    return item.id !== 'prv';
  }

  getCityByZip() {
    if (this.user.address.zip && this.user.address.country === 'NORGE') {
      if (this.user.address.zip.length === 4) {
        this.commonService.getCityByPostCode(this.user.address.zip)
          .then((resp) => {
            this.user.address.city = resp.data.city ? resp.data.city : 'OLSO';
          });
      }
    }
  }

  compare(str1, str2) {
    return str1 !== str2;
  }

  register() {
    $('input[type="submit"]').attr('disabled', true);
    this.errors = [];

    if (this.user.orgNo) {
      this.user.orgNo = this.user.orgNo.trim();
    }

    if (this.user.accountNo) {
      this.user.accountNo = this.user.accountNo.trim();
    }

    this.userService.register(this.user, this.captchaResponse)
      .then(() => {
        this.userService.login(this.user.username, this.user.password)
          .then(() => {
            this.$window.location.href = '/side/#/';
          });
      })
      .catch((err) => {
        this.vcRecaptchaService.reload();

        if (err.data && err.data.validationResult) {
          for (let i in err.data.validationResult) {
            if (err.data.validationResult[i]) {
              $('#' + err.data.validationResult[i].field).addClass('error');

              this.errors.push({
                type: 'error',
                message: err.data.validationResult[i].message
              });
            }
          }
        }

        $('input[type="submit"]').attr('disabled', false);
      });
  }
}

UserRegister.$inject = ['$scope', '$window', 'userService', 'commonService', 'vcRecaptchaService'];

angular
  .module('SendRegning')
  .controller('UserRegister', UserRegister);
